import React from 'react';

export default function LoadingState({ message = 'Loading...' }) {
  return (
    <div className="mol-loading-state">
      <div className="mol-loading-spinner" />
      <p>{message}</p>
    </div>
  );
}
